import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import { MedphotoContext } from "medphoto.context";
import { fileApi } from "config";

import "./index.scss";

export const ImageCard = ({ image, onRemove, pnr }: { image: UploadImage; onRemove: () => void; pnr: string }) => {
  const { unit } = useContext(MedphotoContext);
  const [progress, setProgress] = useState<"default" | "sending" | "error" | "sent">("default");
  const [openConfirmRemove, setOpenConfirmRemove] = useState(false);
  const [openConfirmSend, setOpenConfirmSend] = useState(false);

  const handleSendImage = () => {
    let form_data = new FormData();
    form_data.append("image", image.inputFile);
    form_data.append("unit", unit!.id.toString());

    setProgress("sending");

    fileApi
      .post(`patient/patient-pictures/` + pnr + "/", form_data)
      .then((res) => {
        setProgress("sent");
      })
      .catch((error) => {
        setProgress("error");
      });
  };

  return (
    <div className="image-container">
      <img alt="" src={image.data} />
      {progress === "error" && (
        <Typography variant="h5" color="red" textAlign="center">
          Kunde inte skicka bilden
        </Typography>
      )}
      <div className="button-container">
        {progress !== "sent" ? (
          <>
            <Button
              onClick={() => setOpenConfirmRemove(true)}
              disabled={progress === "sending"}
              fullWidth
              variant="outlined"
              color="error"
            >
              Ta bort
            </Button>
            <LoadingButton
              onClick={() => setOpenConfirmSend(true)}
              loading={progress === "sending"}
              fullWidth
              variant="contained"
            >
              Skicka bild
            </LoadingButton>
          </>
        ) : (
          <Typography variant="h5" color="green" textAlign="center">
            Bild skickad!
          </Typography>
        )}
      </div>
      <Dialog sx={{ "& .MuiDialog-paper": { width: "90%", maxHeight: 435 } }} maxWidth="xs" open={openConfirmRemove}>
        <DialogTitle>Är du säker?</DialogTitle>
        <DialogContent>Vill du ta bort bilden?</DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => setOpenConfirmRemove(false)}>
            Avbryt
          </Button>
          <Button
            onClick={() => {
              onRemove();
              setOpenConfirmRemove(false);
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog sx={{ "& .MuiDialog-paper": { width: "90%", maxHeight: 435 } }} maxWidth="xs" open={openConfirmSend}>
        <DialogTitle>Är du säker?</DialogTitle>
        <DialogContent>Vill du skicka bilden?</DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => setOpenConfirmSend(false)}>
            Avbryt
          </Button>
          <Button
            onClick={() => {
              handleSendImage();
              setOpenConfirmSend(false);
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
